import _defineProperty from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "./index.css";
import { jsx as a, jsxs as s } from "react/jsx-runtime";
import { Link as e } from "@design-system/link";
import c from "classnames";
import { HeadingBlock as i } from "@design-system/heading-block";
import { Typography as n } from "@design-system/typography";
import r from "react";
import { CtaBlock as d } from "@design-system/cta-block";
import { ExtendableImage as l } from "@design-system/extendable-image";
var t = function t(a) {
    return !!r.Children.count(function (a) {
      return r.Children.toArray(a).filter(function (a) {
        return r.isValidElement(a);
      });
    }(a));
  },
  m = function m(_ref) {
    var _c;
    var i = _ref.className,
      n = _ref.children,
      _ref$variant = _ref.variant,
      r = _ref$variant === void 0 ? "standard" : _ref$variant,
      d = _ref.link,
      l = _ref.hasMedia;
    var t = (null == d ? void 0 : d.component) || e;
    return s("article", Object.assign({
      className: c("cds-card", (_c = {}, _defineProperty(_c, "cds-card--variant-".concat(r), r), _defineProperty(_c, "cds-card--no-media", !l), _c), i)
    }, {
      children: [n, d ? a(t, Object.assign({}, d.props, {
        variant: "wrapper",
        className: "cds-card__link"
      })) : null]
    }));
  };
m.CardMedia = function (_ref2) {
  var e = _ref2.image,
    i = _ref2.mediaVariant,
    n = _ref2.children;
  return s("div", Object.assign({
    className: c("cds-card__media", _defineProperty({}, "cds-card__media--variant-".concat(i), i))
  }, {
    children: [n, e && a(l, Object.assign({}, e, {
      className: "cds-card__media-image"
    }))]
  }));
}, m.CardContent = function (_ref3) {
  var e = _ref3.children,
    c = _ref3.headingBlock,
    r = _ref3.disclaimer,
    d = _ref3.category;
  return a("div", Object.assign({
    className: "cds-card__content"
  }, {
    children: s("div", Object.assign({
      className: "cds-card__content-inner"
    }, {
      children: [d ? a(n, {
        className: "cds-card__category",
        content: d,
        variant: "body",
        size: "xs",
        weight: "regular",
        align: null == c ? void 0 : c.align
      }) : null, a(i, Object.assign({}, c, {
        className: "cds-card__heading-block"
      })), t(e) || r ? s("div", Object.assign({
        className: "cds-card__content-bottom"
      }, {
        children: [e, r && a(n, {
          className: "cds-card__disclaimer",
          variant: "body",
          size: "xs",
          tag: "p",
          content: r,
          align: null == c ? void 0 : c.align
        })]
      })) : null]
    }))
  }));
}, m.CardLabel = function (_ref4) {
  var _c3;
  var a = _ref4.labelContent,
    e = _ref4.srOnlyLabelPrefix,
    i = _ref4.labelVariant,
    _ref4$labelSize = _ref4.labelSize,
    n = _ref4$labelSize === void 0 ? "large" : _ref4$labelSize;
  return s("div", Object.assign({
    className: c("cds-card__label", (_c3 = {}, _defineProperty(_c3, "cds-card__label--".concat(n), n), _defineProperty(_c3, "cds-card__label--".concat(i), i), _c3))
  }, {
    children: [s("span", Object.assign({
      className: "cds-sr-only"
    }, {
      children: [e, " "]
    })), a]
  }));
}, m.CardCTA = function (_ref5) {
  var s = _ref5.ctaBlock;
  return a(d, Object.assign({}, s, {
    className: "cds-card__cta"
  }));
};
export { m as Card };